<template>
  <div class="buy">
    <Row justify="center" type="flex">
      <Col span="24">
        <img
          style="width: 100%; height: 400px"
          src="../../static/img/WisdomSite/背景.png"
          alt="#"
        />
      </Col>
      <Col :xs="19" :sm="19" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col span="24" class="col_bread">
            <div
              style="
                display: flex;
                width: 100%;
                height: 50px;
                background: #343a40;
              "
            >
              <ul class="navigation">
                <li @click="WisdomSite">VR/MR</li>
                <li @click="projection">智慧消防区</li>
                <li @click="skipQuality">智能展示区</li>
              </ul>
            </div>
          </Col>
        </Row>
        <div class="buy_menu01">
          <router-view></router-view>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "Buy",
  data() {
    return {
      menuTheme: "light",
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    getMoney(item) {
      this.$router.push({
        path: "/home/buyGo",
        query: {
          money: item.money,
          ref: item.ref,
          photoUrl1: item.photoUrl1,
          classify: JSON.stringify(item.classify),
        },
      });
    },
    /*导航菜单点击事件*/
    onMenuSelect: function (name) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    // 跳转智慧工地
    WisdomSite() {
      this.$router.push({
        path: "/home/Buy/WisdomSite",
      });
    },
    /*跳转到企业产品的VR安全体验馆*/
    skipVR() {
      this.$router.push({
        path: "/home/Buy/VR",
      });
    },
    // 智慧党建滑轨屏
    SlideScreen() {
      this.$router.push({
        path: "/home/Buy/SlideScreen",
      });
    },
    /*跳转到建筑工程体验馆*/
    skipExperience() {
      this.$router.push({
        path: "/home/Buy/Experience",
      });
    },
    /*跳转到AR质量样板*/
    skipAR() {
      this.$router.push({
        path: "/home/Buy/AR",
      });
    },
    /*跳转到工法质量样板版展示区*/
    skipQuality() {
      this.$router.push({
        path: "/home/Buy/Quality",
      });
    },
    /*工法质量样板展示柜*/
    skipThreeDimensional() {
      this.$router.push({
        path: "/home/Buy/ThreeDimensional",
      });
    },
    /*智能回弹仪*/
    skipHuiTan() {
      this.$router.push({
        path: "/home/Buy/Resiliometer",
      });
    },
    /*智能靠尺*/
    skipRule() {
      this.$router.push({
        path: "/home/Buy/Rule",
      });
    },
    /*激光测距仪*/
    skipCeJu() {
      this.$router.push({
        path: "/home/Buy/Diastimeter",
      });
    },
    /*游标卡尺*/
    skipVernierCaliper() {
      this.$router.push({
        path: "/home/Buy/VernierCaliper",
      });
    },
    /*互动电子沙盘*/
    skipInteraction() {
      this.$router.push({
        path: "/home/Buy/Interaction",
      });
    },
    /*跳转到安全教育*/
    skipSafetyEducation() {
      this.$router.push({
        path: "/home/Buy/SafetyEducation",
      });
    },
    // 智慧投影
    projection() {
      this.$router.push({
        path: "/home/Buy/Projection",
      });
    },
  },
};
</script>

<style scoped>
/**/
.buy_menu {
  margin: 20px 0 20px 0;
}

.buy_menu ul {
  z-index: 1;
  background-color: white;
  margin-top: 14px;
}

.buy_menu ul a {
  background-color: #f8f8f8;
  width: 192px;
  font-size: 16px;
  font-family: 微软雅黑, serif;
  background-image: linear-gradient(to bottom, #fff, #e7e7e7);
}

.buy_menu ul li {
  width: 192px;
  font-size: 16px;
  font-family: 微软雅黑, serif;
  background-image: linear-gradient(to bottom, #fff, #e7e7e7);
}

.buy_menu ul li ul a {
  font-size: 14px;
}

.buy_menu ul a img,
.buy_menu ul li img {
  position: relative;
  top: 2px;
  margin-left: -14px;
}

/**/
.buy {
  width: 100%;
  /* height: 1100px; */
  background: white;
}

.buy_menu01 {
  margin: 14px 0;
}

.navigation {
  width: 100%;
  margin-left: 6%;
}

.navigation li {
  width: 15%;
  display: inline-block;
  text-align: center;
  line-height: 50px;
  color: #fff;
  cursor: pointer;
}

.navigation li:hover {
  background-color: #2d8cf0;
}

.navigation li .router-link-active {
  color: blue;
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy.vue